import React, { memo } from 'react'

import ClosedLost from './drawer/index'
import {
  setAanReasons,
  setClosedLossDrawerMode,
  setClosedLossDrawerOpen,
  setClosedLossDrawerReason,
  setClosedLossDrawerSubReasonOtherText,
  setClosedLossDrawerSubReasons,
  setClosedLossDrawerType,
  setUAMDeclineEscalation,
  setUAMDeclineModalOpen,
} from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { Drawer } from '@/components/Drawer/DrawerV2'

const ClosedLostDrawer = ({
  isOpen,
  application,
  setActualState = null,
  modalCloseCallback = null,
}) => {
  const dispatch = useAppDispatch()
  const mode = useAppSelector((state) => state.general.closedLossDrawerMode)
  const setIsOpen = mode === 'closed-loss' ? setClosedLossDrawerOpen : setUAMDeclineModalOpen

  return (
    <Drawer
      title={`Workflow / ${mode === 'closed-loss' ? 'Closed Lost Details' : 'Decline'}`}
      isOpen={isOpen}
      setIsOpen={(isOpen) => {
        dispatch(setIsOpen(isOpen))
        dispatch(setClosedLossDrawerType(''))
        dispatch(setClosedLossDrawerReason(''))
        dispatch(setClosedLossDrawerSubReasons([]))
        dispatch(setClosedLossDrawerSubReasonOtherText(''))
        dispatch(setClosedLossDrawerReason(''))
        dispatch(setUAMDeclineEscalation(null))
        dispatch(setClosedLossDrawerMode('closed-loss'))
        dispatch(setAanReasons([]))
      }}
    >
      <ClosedLost
        application={application}
        setActualState={setActualState}
        modalCloseCallback={modalCloseCallback}
        mode={mode}
      />
    </Drawer>
  )
}

export default memo(ClosedLostDrawer)
